<template>
  <div class="komoditas">
               
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
       
        <v-flex lg6 sm6 xs12>
          <mini-statistic
            v-if="status==='konfirmasi' && komoditasPesananLogistik==='true'"
            head="Status"
            icon="fas fa-sync-alt"
            sub-title='Sedang Diproses'
            color="success"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status==='konfirmasi' && komoditasPesananLogistik!=='true'"
            head="Status"
            icon="fas fa-check"
            sub-title='Pemesanan Dikonfirmasi'
            color="success"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status==='tolak'"
            head="Status"
            icon="fas fa-times"
            sub-title="Permintaan Pengiriman Pesanan Ditolak"
            color="error"      
          >
          </mini-statistic>  
          <mini-statistic
            v-if="status!=='konfirmasi' && status!=='tolak'"
            head="Status"
            icon="fas fa-question"
            sub-title="Ditunda"
            color="warning"      
          >
          </mini-statistic>  
        </v-flex>

        <v-flex lg6 sm6 xs12>
          <h5 class="text-xs-center">Konfirmasi Pemesanan</h5>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="error" @click="tolakPermintaan">Tolak</v-btn>
            <v-btn color="success" @click="terimaPermintaan">Terima</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-flex>   
             
        <v-flex lg6 sm6 xs12>
          <v-card>
            <v-container>
              <h5 class="text-xs-center">No. Pesanan</h5>
              <h4 class="text-xs-center"><b>{{komoditasPesananPengirimanID}}</b></h4>
              <p class="text-xs-center">Dibuat Pada:</p>
              <h5 class="text-xs-center"><b>{{ tanggalSekarang }}</b></h5>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex lg6 sm6 xs12>
          <v-card>
            <v-container>
              <h5 class="text-xs-center">No. Kontrak</h5>
              <h4 class="text-xs-center"><b>{{kontrakId}}</b></h4>
              <p class="text-xs-center">Dibuat Pada:</p>
              <h5 class="text-xs-center"><b>{{ tanggalSekarang }}</b></h5>
            </v-container>
          </v-card>
        </v-flex>
             
      </v-layout>
    </v-container>

    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg12>
          <v-card class="elevation-1 pa-3 non-printable">
            <v-card-text class="wrapper">

              <div class="page">
                <div class="layout column align-center">
                  <img src="/static/logo-agroforestcape.png" alt="Agroforestcape" width="120" height="120">
                  <h2 class="flex my-4 primary--text">Agroforestcape</h2>
                </div>                
              </div>

              <br>

              <div class="page">
                <div class="layout row">
                  <h4><b>Pelaku Usaha</b></h4>
                </div>

                <div class="layout row">
                  <div class="layout column">
                    <p class="flex my-2 text-xs-left"><b>Penyedia Pengiriman</b></p>
                    <p class="flex my-1 text-xs-left">Nama: <b>{{penyediaJasaPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">Entitas: <b>{{penyediaJasaPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenyediaJasaPengiriman}}</b></p>
                  </div>                

                  <div class="layout column sub-border">
                    <p class="flex my-2 text-xs-left"><b>Pembeli (Pelanggan)</b></p>
                    <p class="flex my-1 text-xs-left">Nama: <b>{{pembeli}}</b></p>
                    <p class="flex my-1 text-xs-left">Entitas: <b>{{entitasPembeli}}</b></p>
                    <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPembeli}}</b></p>
                  </div>                

                  <div class="layout column sub-border">
                    <p class="flex my-2 text-xs-left"><b>Penjual</b></p>
                    <p class="flex my-1 text-xs-left">Nama: <b>{{penjual}}</b></p>
                    <p class="flex my-1 text-xs-left">Entitas: <b>{{entitasPenjual}}</b></p>
                    <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenjual}}</b></p>
                  </div>                

                  <div class="layout column sub-border">
                    <p class="flex my-2 text-xs-left"><b>Penerima</b></p>
                    <p class="flex my-1 text-xs-left">Nama: <b>{{penerima}}</b></p>
                    <p class="flex my-1 text-xs-left">Entitas: <b>{{lokasiPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenerima}}</b></p>
                  </div>                
                </div>
              </div>

              <br>

              <div class="page">
                <div class="layout row">
                  <h4><b>Penjelasan Pesanan Pengiriman</b></h4>
                </div>

                <div class="layout row">
                  <div class="layout column">
                    <p class="flex my-2 text-xs-left"><b>Bagian Umum</b></p>
                    <p class="flex my-1 text-xs-left">Kuantitas (<b>{{unitKuantitas}}</b>): <b>{{kuantitas}}</b></p>
                    <p class="flex my-1 text-xs-left">Komoditas: <b>{{komoditas}}</b></p>
                    <p class="flex my-1 text-xs-left">Tingkat Kualitas: <b>{{kualitas}}</b></p>
                    <p class="flex my-1 text-xs-left">Musim: <b>{{musim}}</b></p>
                    <p class="flex my-1 text-xs-left">Pengirim: <b>{{pengirim}}</b></p>
                    <p class="flex my-1 text-xs-left">Lokasi Penjemputan: <b>{{lokasiPenjemputan}}</b></p>
                    <p class="flex my-1 text-xs-left">Tanggal Mulai Pengiriman: <b>{{tanggalMulaiPengiriman}} {{waktuMulaiPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">No Pesanan Penjemputan: <b>{{kodePenjualanPenjemputan}}</b></p>
                    <p class="flex my-1 text-xs-left">Penerima: <b>{{penerima}}</b></p>
                    <p class="flex my-1 text-xs-left">Lokasi Pengiriman: <b>{{lokasiPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">Tanggal Berakhir Pengiriman: <b>{{tanggalBerakhirPengiriman}} {{waktuBerakhirPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">No Pesanan Pengiriman: <b>{{kodePenjualanPengiriman}}</b></p>
                    <p class="flex my-1 text-xs-left">Est. Jarak Tempuh (Km): <b>{{jarakTempuh}}</b></p>
                    <p class="flex my-1 text-xs-left">Est. Waktu Pengiriman (Jam): <b>{{waktuTempuh}}</b></p>
                  </div>                
                </div>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import { getPerusahaan } from '@/api/perusahaan';
import { Items as Users } from '@/api/perusahaan';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import moment from 'moment'

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget,
    MiniStatistic
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Nama Usaha',
            value: 'nama'
          },
          {
            text: 'Kode Penjualan',
            value: 'kode'
          },
          {
            text: 'Narahubung',
            value: 'narahubung'
          },
          {
            text: 'No Hp',
            value: 'phone'
          },
          {
            text: 'Alamat',
            value: 'alamat'
          },
          {
            text: 'Website',
            value: 'website'
          },
          {
            text: 'Unit Usaha Utama',
            value: 'unitUsaha'
          },
          {
            text: 'Terdaftar',
            value: 'status'
          },
          {
            text: 'Tindakan',
            value: ''
          },
        ],
        items: Users
      },

      // Bagian Umum 
      kodePenjualan: localStorage.kontrakKodePenjualan,
      komoditas: localStorage.kontrakKomoditas,
      dokumen: localStorage.kontrakDokumen,

      // Pelaku Usaha
      penjual: localStorage.kontrakPenjual,
      entitasPenjual: localStorage.kontrakEntitasPenjual,
      kontakPenjual: localStorage.kontrakKontakPenjual,
      emailPenjual: localStorage.kontrakEmailPenjual,
      faxPenjual: localStorage.kontrakFaxPenjual,
      alamatJalanPenjual: localStorage.kontrakAlamatJalanPenjual,
      alamatKelurahanPenjual: localStorage.kontrakAlamatKelurahanPenjual,
      alamatKecamatanPenjual: localStorage.kontrakAlamatKecamatanPenjual,
      alamatKabupatenPenjual: localStorage.kontrakAlamatKabupatenPenjual,
      alamatKotaPenjual: localStorage.kontrakAlamatKotaPenjual,
      alamatProvinsiPenjual: localStorage.kontrakAlamatProvinsiPenjual,
      alamatKodePosPenjual: localStorage.kontrakAlamatKodePosPenjual,

      pembeli: localStorage.kontrakPembeli,
      entitasPembeli: localStorage.kontrakEntitasPembeli,
      kontakPembeli: localStorage.kontrakKontakPembeli,
      emailPembeli: localStorage.kontrakEmailPembeli,
      faxPembeli: localStorage.kontrakFaxPembeli,
      alamatJalanPembeli: localStorage.kontrakAlamatJalanPembeli,
      alamatKelurahanPembeli: localStorage.kontrakAlamatKelurahanPembeli,
      alamatKecamatanPembeli: localStorage.kontrakAlamatKecamatanPembeli,
      alamatKabupatenPembeli: localStorage.kontrakAlamatKabupatenPembeli,
      alamatKotaPembeli: localStorage.kontrakAlamatKotaPembeli,
      alamatProvinsiPembeli: localStorage.kontrakAlamatProvinsiPembeli,
      alamatKodePosPembeli: localStorage.kontrakAlamatKodePosPembeli,

      // Penjelasan Kontrak
      jenisKontrak: localStorage.kontrakJenisKontrak,
      kuantitas: localStorage.kontrakKuantitas,
      unitKuantitas: localStorage.kontrakUnitKuantitas,
      kualitas: localStorage.kontrakKualitas,
      hargaKomoditas: localStorage.kontrakHargaKomoditas,
      tempatPembayaran: localStorage.kontrakTempatPembayaran,
      musim: localStorage.kontrakMusim,
      jalurPengiriman: localStorage.kontrakJalurPengiriman,
      skalaPembayaran: localStorage.kontrakSkalaPembayaran,
      batasTanggalPembayaran: localStorage.kontrakBatasTanggalPembayaran,
      batasWaktuPembayaran: localStorage.kontrakBatasWaktuPembayaran,
      toleransi: localStorage.kontrakToleransi,
      daerahPemasaran: localStorage.kontrakDaerahPemasaran,
      provinsiPemasaran: localStorage.kontrakProvinsiPemasaran, 

      // Rincian Pengiriman
      pengirim: localStorage.kontrakPengirim,
      kontakPengirim: localStorage.kontrakKontakPengirim,
      lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
      alamatJalanPenjemputan: localStorage.kontrakAlamatJalanPenjemputan,
      alamatKelurahanPenjemputan: localStorage.kontrakAlamatKelurahanPenjemputan,
      alamatKecamatanPenjemputan: localStorage.kontrakAlamatKecamatanPenjemputan,
      alamatKabupatenPenjemputan: localStorage.kontrakAlamatKabupatenPenjemputan,
      alamatKotaPenjemputan: localStorage.kontrakAlamatKotaPenjemputan,
      alamatProvinsiPenjemputan: localStorage.kontrakAlamatProvinsiPenjemputan,
      alamatKodePosPenjemputan: localStorage.kontrakAlamatKodePosPenjemputan,

      penerima: localStorage.kontrakPenerima,
      kontakPenerima: localStorage.kontrakKontakPenerima,
      lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
      alamatJalanPengiriman: localStorage.kontrakAlamatJalanPengiriman,
      alamatKelurahanPengiriman: localStorage.kontrakAlamatKelurahanPengiriman,
      alamatKecamatanPengiriman: localStorage.kontrakAlamatKecamatanPengiriman,
      alamatKabupatenPengiriman: localStorage.kontrakAlamatKabupatenPengiriman,
      alamatKotaPengiriman: localStorage.kontrakAlamatKotaPengiriman,
      alamatProvinsiPengiriman: localStorage.kontrakAlamatProvinsiPengiriman,  
      alamatKodePosPengiriman: localStorage.kontrakAlamatKodePosPengiriman,

      // Detail Pengiriman
      tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
      waktuMulaiPengiriman: localStorage.kontrakWaktuMulaiPengiriman,
      tanggalBerakhirPengiriman: localStorage.kontrakTanggalBerakhirPengiriman,
      waktuBerakhirPengiriman: localStorage.kontrakWaktuBerakhirPengiriman,

      // Penjelasan Barang
      jenisPengepakan: localStorage.kontrakJenisPengepakan,

      // Kondisi Kontrak
      kondisiUmum: localStorage.kontrakKondisiUmum,
      kondisiKhusus: localStorage.kontrakKondisiKhusus,

      // Penilaian Kontrak
      nilai: localStorage.kontrakNilai,
      maxNilai: localStorage.kontrakMaxNilai,
      tanggalJatuhTempo: localStorage.kontrakTanggalJatuhTempo,
      waktuJatuhTempo: localStorage.kontrakWaktuJatuhTempo,

      // Usaha Pedagang Perantara
      jenisPembayaran: localStorage.kontrakJenisPembayaran,

      // Administrasi
      invoicing: localStorage.kontrakInvoicing,
      perantara: localStorage.kontrakPerantara,
      entitasPerantara: localStorage.kontrakEntitasPerantara,
      kontakPerantara: localStorage.kontrakKontakPerantara,
      catatanPedagang: localStorage.kontrakCatatanPedagang,

      // Sistem
      kontrakAktif: localStorage.kontrakActiveCurrentDate,
      kontrakId: localStorage.kontrakID,
      komoditasPesananPengirimanStatus: localStorage.komoditasPesananPengiriman,  
      komoditasPesananPengirimanAktif: localStorage.komoditasPesananPengirimanAktif,
      komoditasPesananPengirimanID: localStorage.komoditasPesananPengirimanID,
      komoditasStatusPedagangPerantara: localStorage.komoditasPesananPedagangPerantara,

      // Komoditas
      jenisPengirimanPesanan: localStorage.komoditasJenisPengirimanPesanan,
      penyediaJasaPengiriman: localStorage.komoditasPenyediaJasaPengiriman,
      kontakPenyediaJasaPengiriman: localStorage.komoditasKontakPenyediaJasaPengiriman,
      tanggalMulaiPenjemputan: localStorage.komoditasTanggalMulaiPenjemputan,
      waktuMulaiPenjemputan: localStorage.komoditasWaktuMulaiPenjemputan,
      kodePenjualanPenjemputan: localStorage.komoditasKodePenjualanPenjemputan,
      kodePenjualanPengiriman: localStorage.komoditasKodePenjualanPengiriman,
      faktur: localStorage.komoditasFaktur,
      jarakTempuh: localStorage.komoditasJarakTempuh,
      waktuTempuh: localStorage.komoditasWaktuTempuh,
      nilaiKomisi: localStorage.komoditasNilaiKomisi,
    };
  },

  computed: {
    users () {
      return getUser();
    },
    status(){
      return localStorage.komoditasStatusLogistik
    },
    tanggalSekarang(){
      return moment().format('DD-MM-YYYY');
    }

  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    tolakPermintaan () {
      this.komoditasStatusLogistik = 'tolak'
      this.pesananLogistik = 'false'
      localStorage.komoditasPesananLogistik = this.pesananLogistik
      localStorage.komoditasStatusLogistik = this.komoditasStatusLogistik      
      window.getApp.$emit('APP_CONFIRMATION_REJECT');
    },

    terimaPermintaan () {
      this.komoditasStatusLogistik = 'konfirmasi'
      this.pesananLogistik = 'false'
      localStorage.komoditasPesananLogistik = this.pesananLogistik
      localStorage.komoditasStatusLogistik = this.komoditasStatusLogistik      
      window.getApp.$emit('APP_CONFIRMATION_ACCEPT');
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    },

    formatPrice(value) {
      let val = (value/1)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 0.9em;
  }

  .border{
    border-bottom: 1px solid;
  }

  .sub-border{
    border-left: 1px solid;   
    padding-left: 1vw; 
  }

</style>
